"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractExerciseHandler = void 0;
const exercise_js_1 = require("@app/routes/SpeechDevelopment/reducers/exercise.js");
const sendInfoReport_1 = require("@app/utils/sendInfoReport");
// Module-level state for time tracking (persists across handler re-instantiations)
let _infoRep = [];
class AbstractExerciseHandler {
    get current() {
        const currentIndex = (0, exercise_js_1.selectCurrentIndex)(this.store);
        return this.data[currentIndex];
    }
    get currentIndex() {
        return (0, exercise_js_1.selectCurrentIndex)(this.store);
    }
    get recognizedWords() {
        return (0, exercise_js_1.selectRecognizedWords)(this.store);
    }
    get answers() {
        return (0, exercise_js_1.selectAnswers)(this.store);
    }
    get isChecked() {
        return this._isChecked;
    }
    set isChecked(value) {
        this._isChecked = value;
    }
    constructor({ exerciseParams, langId, addCoin, store, dispatch, }) {
        var _a;
        this._isChecked = false;
        this.data = (_a = exerciseParams.text) === null || _a === void 0 ? void 0 : _a.offers;
        this.dispatch = dispatch;
        this.langId = langId;
        this.addCoin = addCoin;
        this.store = store;
        this.exerciseInfo = {
            id: exerciseParams.id,
            number: exerciseParams.number,
        };
    }
    updateAnswers(answer) {
        this.isChecked = true;
        this.dispatch((0, exercise_js_1.setAnswers)(this.answers.concat(answer)));
    }
    handleAnswer(inputAnswer) {
        return __awaiter(this, void 0, void 0, function* () {
            const isCorrect = this.checkIsCorrectAnswer(inputAnswer);
            if (isCorrect) {
                this.dispatch((0, exercise_js_1.setUserRightAnswer)(inputAnswer));
                yield this.handleCorrectAnswer();
            }
            else
                yield this.handleWrongAnswer();
            return isCorrect;
        });
    }
    // TODO: this utilitarian methods below are not related with class logic and its purpose - move outside
    /** Initialize infoRep for a new exercise. Call once when exercise starts. */
    initInfoRep(firstRepId) {
        _infoRep = [{ rep_id: firstRepId, category_name: '', system_time: '', startTime: Date.now() }];
        console.log('[ExerciseReport] initInfoRep, repId:', firstRepId);
    }
    /** Track end of current repetition. If nextRepId is given, starts timing the next rep. */
    trackRepEnd(isCorrect, nextRepId) {
        _infoRep = (0, sendInfoReport_1.trackAttemptTime)(_infoRep, isCorrect);
        console.log('[ExerciseReport] rep ended, correct=' + isCorrect + ', infoRep:', JSON.stringify(_infoRep));
        if (nextRepId !== undefined) {
            _infoRep = [
                ..._infoRep,
                { rep_id: nextRepId, category_name: '', system_time: '', startTime: Date.now() },
            ];
        }
    }
    /** Send the accumulated report. Call in stopExercise(). */
    sendExerciseReport(exerciseId, answers) {
        console.log('[ExerciseReport] sending report, infoRep:', JSON.stringify(_infoRep));
        (0, sendInfoReport_1.sendInfoReport)(_infoRep, exerciseId, window.userId, answers);
    }
}
exports.AbstractExerciseHandler = AbstractExerciseHandler;
